import {
  Alert,
  AlertTitle,
  Table,
  TableCell,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

function DynamicForm({ rfqDetails, type = null, policyDetail = null }) {
  const [dynamicFormStructure, setDynamicFormStructure] = useState([]);

  useEffect(() => {
    let data = [];
    if (rfqDetails?.dynamicFormData?.length) {
      data = rfqDetails.dynamicFormData;
    } else if (rfqDetails?.rfqTemplate?.dynamicFormmStructure) {
      data = rfqDetails.rfqTemplate.dynamicFormmStructure;
    }
    setDynamicFormStructure(data || []);
  }, [rfqDetails]);

  /* ---------------- Layout Models ---------------- */

  const qcCell = {
    width: '50%',
    maxWidth: '50%',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '16px',
    overflowWrap: 'break-word',
    minWidth: 0,
  };

  const placementCell = {
    width: '36.3vw',
    maxWidth: '36.3vw',
    paddingLeft: '0px',
    overflowWrap: 'break-word',
    minWidth: 0,
  };

  const cellStyle = type === 'qc' ? qcCell : placementCell;

  /* ---------------- Renderer ---------------- */

  const renderValue = (field) => {
    const val = field.value;

    if (!val || val === '') return 'N/A';

    if (field.type === 'Checkbox') {
      if (Array.isArray(val)) {
        const filtered = val.filter(i => i?.value?.trim());
        return filtered.length
          ? filtered.map((i, idx) => <div key={idx}>{i.value}</div>)
          : 'N/A';
      }
      return val.trim() || 'N/A';
    }

    if (field.type === 'MultiSelectDropdown') {
      return Array.isArray(val) && val.length
        ? val.map((v, i) => <div key={i}>{v}</div>)
        : 'N/A';
    }

    if (field.type === 'DatePicker') {
      return moment(val).isValid()
        ? moment(val).format('DD-MM-YYYY')
        : 'N/A';
    }

    if (Array.isArray(val)) {
      return field.isIncremental
        ? val.length ? val.join(', ') : 'N/A'
        : val.join(', ');
    }

    if (typeof val === 'object') {
      return val.label || val.name || JSON.stringify(val);
    }

    return val;
  };

  /* ---------------- Render ---------------- */

  return (
    <Table
      sx={{
        width: type === 'qc' ? '100%' : 'auto',
        tableLayout: type === 'qc' ? 'fixed' : 'auto',
        pointerEvents: 'none',
      }}
    >
      {dynamicFormStructure.map((form, gi) => (
        <React.Fragment key={gi}>
          {form.groupName && (
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  background: 'rgb(9 84 174)',
                  color: '#fff',
                  paddingTop: '4px',
                  paddingBottom: '4px',
                }}
              >
                {form.groupName}
              </TableCell>
            </TableRow>
          )}

          {!form.masterForms?.length ? (
            <TableRow>
              <TableCell colSpan={2}>
                <Alert severity="warning">
                  <AlertTitle>Input Fields not added for this section</AlertTitle>
                </Alert>
              </TableCell>
            </TableRow>
          ) : (
            form.masterForms.map((field, i) => (
              <TableRow key={i}
                style={{
                  opacity: (
                    policyDetail?.parentqcData ||
                    policyDetail?.insurancePolicy?.qcData
                  )?.dynamic_form_detail?.status === 'approve'
                    ? 0.5
                    : 1,
                  pointerEvents:
                    (
                      policyDetail?.parentqcData ||
                      policyDetail?.insurancePolicy?.qcData
                    )?.dynamic_form_detail?.status === 'approve'
                      ? 'none'
                      : 'auto',

                }}
              >
                <TableCell
                  sx={{
                    ...cellStyle,
                    fontStyle: field.style?.italic ? 'italic' : 'normal',
                    fontWeight: field.style?.bold ? 'bold' : 'normal',
                    textDecoration: field.style?.underline ? 'underline' : 'none',
                  }}
                >
                  {field.hideLabel ? '' : field.label}
                </TableCell>

                <TableCell
                  sx={{
                    ...cellStyle,
                    paddingLeft: type === 'qc' ? '16px' : '2px',
                    fontStyle: field.style?.italic ? 'italic' : 'normal',
                    fontWeight: field.style?.bold ? 'bold' : 'normal',
                    textDecoration: field.style?.underline ? 'underline' : 'none',
                  }}
                >
                  {renderValue(field)}
                </TableCell>
              </TableRow>
            ))
          )}
        </React.Fragment>
      ))}
    </Table>
  );
}

export default DynamicForm;
